export const RECEIPT_HEADER = "RECEIPT_HEADER";
export const ACCOUNT_FORM = "ACCOUNT_FORM";
